import { AxiosError, AxiosInstance } from 'axios'
import { AccountFitSettings } from 'constants/firmographics'

import { createAuthedHttpClient } from '@driftt/web-auth'

import config from 'config'
import { captureExceptionWithMessage } from 'utils/logRocket'

const logErrorHandler = (error: AxiosError) => {
  captureExceptionWithMessage('Account Scoring API Error', error, {
    url: window.location.href,
    endpoint: error.config.url,
    errorData: JSON.stringify(error.config)
  })
}

const responseErrorHandlers = [logErrorHandler]

export const AccountScoringAPI: AxiosInstance = createAuthedHttpClient({
  responseErrorHandlers,
  baseConfig: {
    baseURL: config.ACCOUNT_SCORING_API
  }
})
export const fetchGoodFitScore = (accountId: string) => {
  return AccountScoringAPI.get(`accountFitScore?accountId=${accountId}`).then(res => res.data)
}

export const fetchAccountFitFirmographics = () => {
  return AccountScoringAPI.get<AccountFitSettings>('featureWeights').then(res => res.data)
}

export const setAccountFitFirmographics = (req: AccountFitSettings) => {
  return AccountScoringAPI.post('featureWeights', req).then(res => res.data)
}
